<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#abot-announcement-icon-clip)">
      <path
        d="M14.3866 5.25556C14.2826 5.34 14.2222 5.46711 14.2222 5.60134V7.73378C14.2222 7.868 14.2826 7.99422 14.3866 8.07867C14.4906 8.16311 14.6275 8.196 14.7582 8.16845C15.4888 8.01467 15.9999 7.39689 15.9999 6.66711C15.9999 5.93734 15.4888 5.31956 14.7582 5.16578C14.6275 5.13822 14.4906 5.17111 14.3866 5.25556Z"
        fill="currentColor"
      />
      <path
        d="M4.44447 3.10938C2.48358 3.10938 0.888916 4.70404 0.888916 6.66493C0.888916 8.62582 2.48358 10.2205 4.44447 10.2205V3.10938Z"
        fill="currentColor"
      />
      <path
        d="M12.4372 0.926744C12.1679 0.8343 11.8701 0.923189 11.695 1.14897C11.2719 1.69563 9.86211 3.11252 8.44433 3.11252H5.77856V10.2236H8.44433C10.143 10.2236 11.6808 12.1685 11.6959 12.1881C11.8248 12.3534 12.0203 12.445 12.2221 12.445C12.295 12.445 12.3679 12.4334 12.439 12.4085C12.7083 12.3161 12.8888 12.0636 12.8888 11.7792V6.66808V1.55697C12.8888 1.27163 12.7074 1.0183 12.4381 0.926744H12.4372Z"
        fill="currentColor"
      />
      <path
        d="M8.4617 13.736C8.63749 14.5687 8.11143 15.3884 7.28162 15.575C6.44189 15.7523 5.61565 15.2158 5.43825 14.3739L4.84839 11.5547L7.99212 11.6305L8.4617 13.736Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="abot-announcement-icon-clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
/** Purpose: Render the brand-colored announcement glyph supplied by the Widget UI design. */
</script>
